// extracted by mini-css-extract-plugin
export default {"header":"Header_header__X8oJv","iconLink":"Header_iconLink__qina8","dashboardIcon":"Header_dashboardIcon__1O4OC"};